import {
  actionChannel,
  take,
  takeLatest,
  takeEvery,
  call,
} from 'redux-saga/effects';
import { buffers } from 'redux-saga';
import * as types from '../constants/ActionTypes';
import {
  SYNC_ENDINGS,
  FETCH_ENDINGS,
  isSyncQuestEnding,
  isFetchQuestEnding,
  fetchUpdatedQuest,
  triggerUpdateQuestData,
  syncQuest,
  updateQuestData,
} from './quests/questsSyncSaga';
import {
  fetchQuest,
  fetchQuests,
  receiveQuests,
  addQuest,
  handleCreateQuestSuccess,
  selectQuest,
  deleteQuest,
  copyQuest,
} from './quests/questsCrudSaga';
import {
  reorderEventsAndPoints,
  replaceImage,
  dragImage,
  toggleMuseum,
  deleteEvent,
} from './quests/questsEventsSaga';

export {
  SYNC_ENDINGS,
  FETCH_ENDINGS,
  isSyncQuestEnding,
  isFetchQuestEnding,
  fetchUpdatedQuest,
  triggerUpdateQuestData,
  syncQuest,
  fetchQuest,
  deleteQuest,
  copyQuest,
  receiveQuests,
  reorderEventsAndPoints,
  replaceImage,
  dragImage,
  toggleMuseum,
  deleteEvent,
};

export default function* watchQuests() {
  yield takeLatest(types.FETCH_QUEST, fetchQuest);
  yield takeLatest(types.FETCH_UPDATED_QUEST, fetchQuest);
  yield takeLatest(types.UPDATE_QUEST_DATA, updateQuestData);
  yield takeLatest(types.ADD_QUEST, addQuest);
  yield takeLatest(types.CREATE_QUEST_SUCCESS, handleCreateQuestSuccess);
  yield takeLatest(types.SELECT_QUEST, selectQuest);
  yield takeEvery(types.DELETE_QUEST, deleteQuest);
  yield takeEvery(types.COPY_QUEST, copyQuest);
  yield takeEvery(types.DELETE_EVENT_SYNC, deleteEvent);
  yield takeLatest(types.FETCH_QUESTS, fetchQuests);
  yield takeLatest(types.RECEIVE_QUESTS, receiveQuests);
  yield takeLatest(types.REORDER_EVENTS_AND_POINTS, reorderEventsAndPoints);
  yield takeLatest(types.REPLACE_EVENT_IMAGE, replaceImage);
  yield takeLatest(types.SYNC_DRAG_EVENT_IMAGE, dragImage);
  yield takeLatest(types.TOGGLE_MUSEUM_SAGA, toggleMuseum);

  const requestSyncChain = yield actionChannel(
    types.SYNC_QUEST,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestSyncChain);
    yield call(syncQuest, action);
  }
}
